<template>
  <ul class="yj-select-group__wrap" v-show="visible">
    <li class="yj-select-group__title">{{ label }}</li>
    <li>
      <ul class="yj-select-group">
        <slot></slot>
      </ul>
    </li>
  </ul>
</template>

<script type="text/babel">
  import Emitter from '@/mixins/emitter';

  export default {
    mixins: [Emitter],

    name: 'YjOptionGroup',

    componentName: 'YjOptionGroup',

    props: {
      label: String,
      disabled: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        visible: true
      };
    },

    watch: {
      disabled(val) {
        this.broadcast('YjOption', 'handleGroupDisabled', val);
      }
    },

    methods: {
      queryChange() {
        this.visible = this.$children &&
          Array.isArray(this.$children) &&
          this.$children.some(option => option.visible === true);
      }
    },

    created() {
      this.$on('queryChange', this.queryChange);
    },

    mounted() {
      if (this.disabled) {
        this.broadcast('YjOption', 'handleGroupDisabled', this.disabled);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/select/src/option-group.vue